import React, { act, useState } from 'react';
import { RouterSwitch } from './RouterSwitch';
import { Route } from 'react-router';
import { useTranslation } from 'react-i18next';
import Drawer from './drawer/Drawer';
import Content from './Content';
import Notifications from '../widget/Notifications';
import Error404 from './Error404';
import TopBar from './TopBar';
import IllegalWasteDumpsList from '../pages/illegal_waste_dumps_list/IllegalWasteDumpsList';
import IllegalWasteDumpsListForm from '../pages/illegal_waste_dumps_list/IllegalWasteDumpsListForm';
import Settings from '../pages/settings/Setting';

import { UserContext } from '../../context/UserContext';
import BreadCrumbsStateful from './BreadCrumbsStateful';
import { Provider } from 'react-redux';
import store from '../../state/store';
import UserList from '../pages/manage_users/UserList';
import EditHistoryList from '../pages/illegal_waste_dumps_list/EditHistoryList';
import Map from '../pages/map/Map';
import Auth from '../../auth/Auth';
import RestrictAccess from '../widget/RestrictAccess';
import { PlotContext } from '../../context/PlotContext';
import PrivacyPolicyPage from "../pages/PrivacyPolicyPage";
import DeleteUserPage from "../pages/settings/DeleteUserPage";
import SupportPage from "../pages/SupportPage";

export const RouteContext = React.createContext(null);

const ApplicationStateful = () => {
	const { t } = useTranslation();
	const routesState = useState({ routes: [], breadcrumbs: [] });
	const [user, setUser] = useState({});
	const [active, setActive] = useState(false);
	const [plot, setPlot] = useState(null);

	const handleClick = () => {
		setActive(true);
	};

	const routes = {
		illegalWasteDumpsList: t('navigation.href.illegal_waste_dumps_list'),
		map: t('navigation.href.map'),
		userManagement: t('navigation.href.user_management'),
		settings: t('navigation.href.settings'),
	};

	return (
		<RouteContext.Provider value={routesState}>
			<RouterSwitch>
				<Route path="/privacy-policy" element={<PrivacyPolicyPage/>} />
				<Route path="/support" element={<SupportPage/>} />
				<Route path="*" element={
					<UserContext.Provider value={{ user, setUser }}>
						<PlotContext.Provider value={{ plot, setPlot }}>
							<Provider store={store}>
								<Auth>
									<Notifications>
										<TopBar active={active} />
										<RouterSwitch>
											<Route path="delete-account" element={<DeleteUserPage />} />
											<Route path="*" element={
												<>
													<Drawer
														url={'this.props.location.pathname'}
														active={active}
														setActive={setActive}
													/>
													<main className={`main-section ${active ? 'is-active' : ''}`}>
														<RestrictAccess allowedRoles={['admin', 'advanced_user']}>
															<Content>
																<BreadCrumbsStateful />
																<RouterSwitch>
																	<Route path="/" element={<Map />} />

																	<Route
																		path={`/${routes.illegalWasteDumpsList}`}
																		name={t('navigation.label.illegal_waste_dumps_list')}>
																		<Route index element={<IllegalWasteDumpsList />} />
																		<Route
																			path={t('navigation.href.create')}
																			name={t('navigation.label.create')}
																			element={<IllegalWasteDumpsListForm />}
																		/>
																		<Route
																			path={t('navigation.href.edit') + '/:id'}
																			name={t('navigation.label.edit')}
																			element={<IllegalWasteDumpsListForm />}
																		/>
																		<Route
																			path={
																				t('navigation.href.edit') +
																				'/:id/' +
																				t('navigation.href.history_change')
																			}
																			name={t('navigation.label.history_change')}
																			element={<EditHistoryList />}
																		/>
																	</Route>

																	<Route
																		path={`/${routes.map}`}
																		name={t('navigation.label.map')}>
																		<Route index element={<Map />} />
																	</Route>

																	<Route
																		path={`/${routes.userManagement}`}
																		name={t('navigation.label.user_management')}>
																		<Route
																			index
																			element={
																				<RestrictAccess allowedRoles={['admin']}>
																					<UserList />
																				</RestrictAccess>
																			}
																		/>
																	</Route>

																	<Route
																		path={`/${routes.settings}`}
																		name={t('navigation.label.settings')}>
																		<Route index element={<Settings />} />
																	</Route>

																	<Route
																		path="*"
																		element={<Error404 />}
																		breadcrumb={false}
																	/>
																</RouterSwitch>
															</Content>
														</RestrictAccess>
													</main>
												</>
											} />
										</RouterSwitch>

									</Notifications>
								</Auth>
							</Provider>
						</PlotContext.Provider>
					</UserContext.Provider>

				}/>
			</RouterSwitch>
		</RouteContext.Provider>
	);
};

export default ApplicationStateful;
